import msm_api from "../../api/msm-api.json";
import {
  useOnlyMdMediaQuery,
  useTabletAndBelowMediaQuery,
} from "../../components/ComponentUtils/Responsive";
import { useStaticQueryDataChatMutuo } from "../../query/useStaticQueryDataChatMutuo";
import { useStaticQueryDataComeFunziona } from "../../query/useStaticQueryDataComeFunziona";
import { CHAT_MUTUO_TOGGLE } from "../../state/actions/chatmutuo.actions";
import { CLEAR_LAST_LANDING_SLUG } from "../../state/actions/navigation.actions";
import { getLastLandingSlug } from "../../state/selectors/navigation.selector";
import { FETCH_MUTUI_BY_ID } from "../../state/thunk/mutui.thunk";
import { flatMenuListToHierarchical } from "../../utils/helpers";
import { handleServiceBarChatClick } from "../../utils/backNavigation";
import ComeFunziona from "../BannerPostNavbarHP/ComeFunziona";
import Image from "../Image";
import Text from "../Text";
import UniversalLink from "../UniversalLink";
import * as serviceBarStyles from "./service-bar.module.scss";
import ChatMutoAvatarMobileSVG from "/static/chat-mutuo-avatar-mobile.svg";
import { useLocation } from "@reach/router";
import classNames from "classnames";
import { AnimatePresence, motion } from "framer-motion";
import { graphql, navigate, useStaticQuery } from "gatsby";
import React, { useEffect, useState, useMemo, useRef } from "react";
import { useActiveSection } from "../../utils/hooks/useActiveSection";
import { Accordion } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import slugify from "slugify";

const accordionVariants = {
  hidden: {
    height: 0,
    pointerEvents: "none",
  },
  visible: {
    height: "100%",
    pointerEvents: "auto",
  },
};

function scrollToRicercatore() {
  const element = document.getElementById("mutui");
  if (element) {
    window.scrollTo({
      top: element.getBoundingClientRect().top + window.scrollY - 120,
      behavior: "smooth",
    });
  }
}

const ServiceBar = ({
  isChatMutuoTemplate = false,
  isHpTemplate = false,
  isHpTemplateLightVersion = false,
  isLandingPageTemplate = false,
  comeFunzionaOverride = null,
}) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const isTablet = useOnlyMdMediaQuery();
  const homeParams =
    useSelector((state) => state.requests.researcher?.HP) || null;
  const lastLandingSlug = useSelector(getLastLandingSlug);
  const [activeKey, setActiveKey] = useState(null);
  const [openAccordionKey, setOpenAccordionKey] = useState(null);
  const menuContainerRef = useRef(null);
  const { acfOptionsComeFunziona } = useStaticQueryDataComeFunziona();
  const comeFunzionaData =
    comeFunzionaOverride?.video?.length > 0
      ? { acfOptionsComeFunziona: comeFunzionaOverride }
      : acfOptionsComeFunziona;

  const {
    chatMutuo: {
      logoMobile,
      assistente: { avatarMobile },
      disattivazioneTotaleChatMutuo,
    },
  } = useStaticQueryDataChatMutuo();

  const isChatMutuoDisabledType = (templateName) =>
    disattivazioneTotaleChatMutuo &&
    (templateName === "ChatMutuo" || templateName === "Landing Page");

  const handleShowMobileMenu = () => {
    if (activeKey === 2) {
      setActiveKey(null);
    } else {
      setActiveKey(2);
    }
  };

  const [showComeFunziona, setShowComeFunziona] = useState(false);
  const handleShowComeFunziona = () => {
    if (activeKey === 1) {
      setActiveKey(null);
    } else {
      setActiveKey(1);
    }
    setShowComeFunziona(true);
  };
  const handleCercaMutuo = () => {
    if (location.pathname === "/") {
      dispatch(
        FETCH_MUTUI_BY_ID({
          id: "HP",
          postData: {
            ...(homeParams?.params || {
              ...msm_api.endpoint.Ricerca.default?.HP,
            }),
          },
          endpoint: "Ricerca",
          type: "HP",
        })
      );
      scrollToRicercatore();
    } else {
      navigate("/");
    }
  };
  
  const handleChatMutuo = () => {
    if (!chatMutuoPage?.slug) return;
    const treatAsReturnTarget = isHpTemplate || isLandingPageTemplate;
    handleServiceBarChatClick(chatMutuoPage.slug, location.pathname, {
      treatAsReturnTarget,
    });
  };

  const handleCercaMutuoOrBackToLanding = () => {
    if (isChatMutuoTemplate && lastLandingSlug) {
      navigate(`/${lastLandingSlug}`);
      dispatch(CLEAR_LAST_LANDING_SLUG());
      return;
    }
    handleCercaMutuo();
  };

  useEffect(() => {
    setActiveKey(null);
    document.body.style.overflow = "auto";
  }, [location]);

  const {
    wp: {
      acfOptionsTema: {
        opzioniTema: { siteLogo, menuMobile },
      },
    },
    allWpMenuItem: { serviceBarMenu },
    menu,
    chatMutuoPage,
  } = useStaticQuery(graphql`
    query serviceBarMenuQuery {
      allWpMenuItem(
        filter: { locations: { eq: SERVICE_BAR_MENU } }

        sort: { order: ASC }
      ) {
        serviceBarMenu: nodes {
          label
          title
          id
          path
          cssClasses
          target
          order
          acfServiceBarMenu {
            nascondiMobile
            icona {
              altText
              height
              width
              title
              localFile {
                extension
                publicURL
                childImageSharp {
                  gatsbyImageData(quality: 100, layout: FULL_WIDTH)
                }
              }
            }
          }
          acfAncoraPagina {
            paginaAncoraId
            paginaAncoraTarget {
              ... on WpPage {
                uri
              }
            }
          }
        }
      }
      menu: allWpMenuItem(filter: { locations: { eq: MAIN_MENU } }) {
        nodes {
          label
          title
          id
          path
          cssClasses
          target
          parentId
          order
          # acfHeaderNavigation {
          # 	sectionTitle
          # }
          connectedNode {
            node {
              ... on WpPage {
                id
                template {
                  templateName
                }
              }
            }
          }
          acfMenuNovita {
            fieldGroupName
            menuNovita
          }
          acfMenuBeta {
            fieldGroupName
            beta
          }
          acfEtichettaCorta {
            fieldGroupName
            nuovaEtichetta
            etichettaCorta
          }
          acfAncoraPagina {
            paginaAncoraId
            paginaAncoraTarget {
              ... on WpPage {
                uri
              }
            }
          }
        }
      }
      wp {
        acfOptionsTema {
          opzioniTema {
            siteLogo: generali {
              logo {
                altText
                localFile {
                  publicURL
                  extension
                  childImageSharp {
                    gatsbyImageData(quality: 100, layout: FULL_WIDTH)
                  }
                }
                height
                width
                title
              }
            }
            menuMobile {
              testoSottoVoceDiMenu
            }
          }
        }
      }
      chatMutuoPage: wpPage(template: {templateName: {eq: "ChatMutuo"}}) {
        slug
      }
    }
  `);

  const logoImageData = siteLogo?.logo || null;
  const hierarchicalList = flatMenuListToHierarchical(menu.nodes);

  const allAnchorIds = useMemo(
    () => hierarchicalList.flatMap(item => [
      item?.acfAncoraPagina?.paginaAncoraId,
      ...(item.children || []).map(c => c?.acfAncoraPagina?.paginaAncoraId),
    ]).filter(Boolean),
    [hierarchicalList]
  );
  const activeSection = useActiveSection(allAnchorIds);

  const defaultOpenAccordionKey = useMemo(() => {
    for (let i = 0; i < hierarchicalList.length; i++) {
      const menuItem = hierarchicalList[i];
      const { path, children } = menuItem;
      if (!children?.length) continue;
      const ancoraTarget = menuItem?.acfAncoraPagina?.paginaAncoraTarget?.uri;
      const ancoraId = menuItem?.acfAncoraPagina?.paginaAncoraId;
      const basePath2 = (ancoraTarget || path).replace(/\/?$/, "/");
      const isActive2 = ancoraId
        ? location.pathname.replace(/\/?$/, "/") === basePath2 && activeSection === ancoraId
        : location.pathname === path;
      const key = `${i}-${slugify(path)}`;
      if (isActive2) return key;
      const hasActiveChild = children.some((child) => {
        const childAncoraTarget = child?.acfAncoraPagina?.paginaAncoraTarget?.uri;
        const childAncoraId = child?.acfAncoraPagina?.paginaAncoraId;
        const childBasePath = (childAncoraTarget || child.path).replace(/\/?$/, "/");
        return childAncoraId
          ? location.pathname.replace(/\/?$/, "/") === childBasePath && activeSection === childAncoraId
          : location.pathname === child.path;
      });
      if (hasActiveChild) return key;
    }
    return null;
  }, [hierarchicalList, location.pathname, activeSection]);

  useEffect(() => {
    if (activeKey !== 2) {
      setOpenAccordionKey(null);
      return;
    }
    setOpenAccordionKey(defaultOpenAccordionKey);
  }, [activeKey, defaultOpenAccordionKey]);

  if (isHpTemplateLightVersion) {
    return null;
  }

  const MenuConditional = ({ templateName, label, novitaClass, beta, isExpanded = false }) => {

    const betaLabel = (beta) ? (<><sup style={{
          fontSize: ".5625rem",
          fontWeight: "bold",
        }}> BETA</sup></>) : ("");

    if (templateName === "ChatMutuo" || templateName === "Landing Page") {
      return (
        <>
          <span style={{ color: isExpanded ? "white" : "#72B043" }}>Chat</span>
          <span style={{ color: isExpanded ? "white" : "#468A4C" }}>Mutuo AI</span>
          <sup
            style={{
              color: "#F37324",
              fontSize: ".5625rem",
              fontWeight: "bold",
            }}
          >
          &nbsp;BETA
          </sup>
        </>
      );
    } else{
      if (novitaClass) {
        return (
          <>
            <span
              style={{
                paddingRight: "5px",
              }}
            >
              <img
                src="/megafono.svg"
                alt="megafono icon"
                width={15}
                height={15}
              />
            </span>
            <span
              // style={{
              //   fontWeight: "bold",
              // }}
            >
              {label}
            </span>
            {betaLabel}
          </>
        );
      } else {
        return (<><span> {label} </span> {betaLabel}</>);
      }
   }
  };

  return (
    <>
      <nav className={serviceBarStyles.serviceBar}>
        <ul>
          <li key={"hamburger-menu"}>
            <button
              className={serviceBarStyles.serviceBarMenuButton}
              onClick={() => handleShowMobileMenu()}
            >
              <div>
                <img
                  src={
                    activeKey === 2 ? "/sbm-menu-close.svg" : "/ico-menu.svg"
                  }
                  alt="hamburger menu"
                  height="20"
                  width="25"
                />
              </div>
              {/* MENU */}
            </button>
          </li>
          <li key={"vantaggi-panel"}>
            <button
              className={serviceBarStyles.serviceBarMenuButton}
              onClick={() => handleShowComeFunziona()}
            >
              <div>
                <img
                  src={
                    activeKey === 1
                      ? "/sbm-menu-close.svg"
                      : "/ico-vantaggi.svg"
                  }
                  alt="icona youtube"
                  height="20"
                  width="25"
                />
              </div>
              {/* VANTAGGI */}
            </button>
          </li>
          {serviceBarMenu.slice(0, !isTablet ? 0 : 1).map((menuItem, i) => {
            const {
              target,
              path,
              label,
              acfServiceBarMenu: { icona, nascondiMobile },
            } = menuItem;
            const ancoraTarget = menuItem?.acfAncoraPagina?.paginaAncoraTarget?.uri;
            const ancoraId = menuItem?.acfAncoraPagina?.paginaAncoraId;
            const baseTarget = ancoraTarget ?? path;
            const finalPath = ancoraId
              ? `${baseTarget.replace(/\/+$/, '')}/#${ancoraId}`
              : path;
            const hideItem = nascondiMobile ? "d-none d-md-inline-block" : null;
            return (
              <li key={`${i}-${path}`} className={hideItem}>
                <UniversalLink to={finalPath} target={target}>
                  <div>
                    <Image data={icona} height="20" width="25" />
                  </div>{" "}
                  a
                </UniversalLink>
              </li>
            );
          })}
          <li
            className={classNames({
              ["d-none"]: !isChatMutuoTemplate,
              ["d-inline-block"]: isChatMutuoTemplate,
            })}
          >
            <button
              onClick={handleCercaMutuoOrBackToLanding}
              className={serviceBarStyles.btnNoStyle}
              aria-label="Cerca Mutuo"
            >
              <div className={serviceBarStyles.fixedIcon}>
                <img
                  className={serviceBarStyles.icon}
                  src="/carrello.svg"
                  alt="banca carrello"
                  width={40}
                  height={40}
                />
              </div>
              CERCA MUTUO
            </button>
          </li>
          <li
            className={classNames({
              ["d-none"]: isChatMutuoTemplate,
              ["d-inline-block"]: !isChatMutuoTemplate,
            })}
          >
            <button
              onClick={() => {
                if (disattivazioneTotaleChatMutuo) {
                  handleCercaMutuo();
                } else {
                  // dispatch(CHAT_MUTUO_TOGGLE());
                  handleChatMutuo();
                }
              }}
              className={serviceBarStyles.btnNoStyle}
              aria-label="Chat Mutuo"
            >
              <div className={serviceBarStyles.fixedIcon}>
                <img
                  className={serviceBarStyles.icon}
                  src={
                    disattivazioneTotaleChatMutuo
                      ? "/carrello.svg"
                      : avatarMobile?.localFile?.publicURL ??
                        ChatMutoAvatarMobileSVG
                  }
                  alt="chat mutuo avatar"
                  width={40}
                  height={40}
                />
              </div>
            </button>
          </li>
          {serviceBarMenu
            .slice(!isTablet ? 0 : 1, !isTablet ? 2 : 5)
            .map((menuItem, i) => {
              let cssClassesLinkItem = menuItem?.cssClasses.length
                ? [...(menuItem?.cssClasses || [])].join(" ")
                : null;
              let {
                target,
                path,
                label,
                acfServiceBarMenu: { icona, nascondiMobile },
              } = menuItem;
              const ancoraTarget = menuItem?.acfAncoraPagina?.paginaAncoraTarget?.uri;
              const ancoraId = menuItem?.acfAncoraPagina?.paginaAncoraId;
              const baseTarget = ancoraTarget ?? path;
              const finalPath = ancoraId
                ? `${baseTarget.replace(/\/+$/, '')}/#${ancoraId}`
                : path;

              let hideItem = nascondiMobile ? "d-none d-md-inline-block" : null;
              return (
                <li key={`${i}-${path}`} className={hideItem}>
                  <UniversalLink
                    to={finalPath}
                    className={cssClassesLinkItem}
                    target={target}
                  >
                    <div>
                      <Image data={icona} height="20" width="25" />
                    </div>
                  </UniversalLink>
                </li>
              );
            })}
        </ul>
      </nav>
      <AnimatePresence>
        <motion.section
          key="showComeFunziona"
          className={classNames(serviceBarStyles.menuMobile)}
          initial="hidden"
          animate={activeKey === 1 ? "visible" : "hidden"}
          variants={accordionVariants}
          transition={{ duration: 0.4 }}
          onAnimationComplete={() => {
            if (activeKey === 1) {
              document.body.style.overflow = "hidden";
            } else {
              document.body.style.overflow = "auto";
            }
          }}
        >
          <div
            className={classNames(
              serviceBarStyles.menuMobileWrapper,
              serviceBarStyles.menuMobileWrapperNoPaddingX
            )}
          >
            <div
              role="button"
              aria-label="Chiudi Menu"
              tabIndex={"0"}
              className={serviceBarStyles.menuMobileClose}
              onClick={() => setActiveKey(null)}
              onKeyDown={(e) => e.key === "Enter" && setActiveKey(null)}
            />
            <div
              className={classNames(
                serviceBarStyles.menuMobileTop,
                serviceBarStyles.menuMobileTopNoPaddingY
              )}
            >
              {logoImageData ? (
                <UniversalLink to="/" aria-label="Vai alla homepage" onClick={() => setActiveKey(null)}>
                  <Image data={logoImageData} />
                </UniversalLink>
              ) : (
                <UniversalLink to="/" aria-label="Vai alla homepage" onClick={() => setActiveKey(null)}>
                  <h2 className="text-black">MSM</h2>
                </UniversalLink>
              )}
            </div>
            <ComeFunziona
              data={comeFunzionaData}
              show={activeKey === 1}
              disableLoader={true}
              classNamePadding={serviceBarStyles.comeFunziona}
              showComeFunziona={showComeFunziona}
            />
          </div>
        </motion.section>
        <motion.section
          key="showMobileMenu"
          className={serviceBarStyles.menuMobile}
          initial="hidden"
          animate={activeKey === 2 ? "visible" : "hidden"}
          variants={accordionVariants}
          transition={{ duration: 0.4 }}
          onAnimationComplete={() => {
            if (activeKey === 2) {
              document.body.style.overflow = "hidden";
              if (menuContainerRef.current) {
                setTimeout(() => {
                  const activeEl =
                    menuContainerRef.current?.querySelector('[aria-expanded="true"]') ||
                    menuContainerRef.current?.querySelector(`.${serviceBarStyles.isActive2}`);
                  activeEl?.scrollIntoView({ behavior: "smooth", block: "nearest" });
                }, 350);
              }
            } else {
              document.body.style.overflow = "auto";
            }
          }}
        >
          <div className={serviceBarStyles.menuMobileWrapper}>
            <div
              role="button"
              aria-label="Chiudi Menu"
              tabIndex={"0"}
              className={serviceBarStyles.menuMobileClose}
              onClick={() => setActiveKey(null)}
              onKeyDown={(e) => e.key === "Enter" && setActiveKey(null)}
            />
            <div className={serviceBarStyles.menuMobileTop}>
              {logoImageData ? (
                <UniversalLink to="/" aria-label="Vai alla homepage" onClick={() => setActiveKey(null)}>
                  <Image data={logoImageData} />
                </UniversalLink>
              ) : (
                <UniversalLink to="/" aria-label="Vai alla homepage" onClick={() => setActiveKey(null)}>
                  <h2 className="text-black">MSM</h2>
                </UniversalLink>
              )}
            </div>
            <Accordion
              as={"nav"}
              flush
              className={serviceBarStyles.menuMobileMenu}
              activeKey={openAccordionKey}
              onSelect={setOpenAccordionKey}
              ref={menuContainerRef}
            >
              {hierarchicalList.map((menuItem, i) => {
                const cssClassesLinkItem = [...menuItem?.cssClasses].join(" ");
                const { target, path, label, children } = menuItem;
                const templateName =
                  menuItem?.connectedNode?.node?.template?.templateName || "";
                if (isChatMutuoDisabledType(templateName)) return null;
                const haveChildren = children?.length > 0 ?? false;
                const key = `${i}-${slugify(path)}`;
                const hasMenuNovita = menuItem?.acfMenuNovita?.menuNovita;
                const isBeta = menuItem?.acfMenuBeta?.beta;
                const ancoraTarget = menuItem?.acfAncoraPagina?.paginaAncoraTarget?.uri;
                const ancoraId = menuItem?.acfAncoraPagina?.paginaAncoraId;
                const basePath2 = (ancoraTarget || path).replace(/\/?$/, '/');
                const isActive2 = ancoraId
                  ? location.pathname.replace(/\/?$/, '/') === basePath2 && activeSection === ancoraId
                  : location.pathname === path && !activeSection;
                const baseTarget = ancoraTarget ?? path;
                const finalPath = ancoraId
                  ? `${baseTarget.replace(/\/+$/, '')}/#${ancoraId}`
                  : path;
                return (
                  <Accordion.Item
                    key={key}
                    eventKey={key}
                    className={serviceBarStyles.accordionItem}
                  >
                    {haveChildren ? (
                      <Accordion.Button
                        className={`${serviceBarStyles.accordionButton}`}
                      >
                        <UniversalLink
                          to={finalPath}
                          className={cssClassesLinkItem}
                          target={target}
                        >
                          {templateName ? (
                            <MenuConditional
                              templateName={templateName}
                              label={label}
                              novitaClass={hasMenuNovita}
                              beta={isBeta}
                              isExpanded={openAccordionKey === key}
                            />
                          ) : (
                            <>
                            {label}

                            {isBeta ? (<> <sup style={{
                                fontSize: ".5625rem",
                                fontWeight: "bold",
                              }}>BETA</sup></>) : ("")}
                            </>
                          )}
                        </UniversalLink>
                      </Accordion.Button>
                    ) : (
                      <div
                        className={`${serviceBarStyles.accordionFullLink} ${serviceBarStyles.accordionButton}`}
                      >
                        <UniversalLink
                          to={finalPath}
                          onClick={() => setActiveKey(null)}
                          className={classNames({
                            cssClassesLinkItem,
                            [serviceBarStyles.isActive2]: isActive2,
                          })}
                          target={target}
                        >
                          <MenuConditional
                            templateName={templateName}
                            label={label}
                            novitaClass={hasMenuNovita}
                            beta={isBeta}
                          />
                        </UniversalLink>
                      </div>
                    )}
                    {haveChildren && (
                      <Accordion.Body
                        className={serviceBarStyles.accordionBody}
                      >
                        <ul>
                          {children.map((menuItem, i) => {
                            const childTemplateName = menuItem?.connectedNode?.node?.template?.templateName || "";
                            if (isChatMutuoDisabledType(childTemplateName)) return null;
                            const cssClassesLinkItem = [
                              ...menuItem?.cssClasses,
                            ].join(" ");
                            const { target, path, label} = menuItem;
                            const key = `${i}-${slugify(path)}`;
                            const childAncoraTarget = menuItem?.acfAncoraPagina?.paginaAncoraTarget?.uri;
                            const childAncoraId = menuItem?.acfAncoraPagina?.paginaAncoraId;
                            const childBasePath = (childAncoraTarget || path).replace(/\/?$/, '/');
                            const isActive = childAncoraId
                              ? location.pathname.replace(/\/?$/, '/') === childBasePath && activeSection === childAncoraId
                              : location.pathname === path && !activeSection;
                            const isBeta = menuItem?.acfMenuBeta?.beta;
                            const childBaseTarget = childAncoraTarget ?? path;
                            const childFinalPath = childAncoraId
                              ? `${childBaseTarget.replace(/\/+$/, '')}/#${childAncoraId}`
                              : path;
                            return (
                              <li key={key}>
                                <UniversalLink
                                  to={childFinalPath}
                                  onClick={() => setActiveKey(null)}
                                  className={classNames({
                                    cssClassesLinkItem,
                                    [serviceBarStyles.isActive]: isActive,
                                  })}
                                  target={target}
                                >
                                  {label}
                                  
                                  {isBeta ? (<> <sup style={{
                                    fontSize: ".5625rem",
                                    fontWeight: "bold",
                                  }}>BETA</sup></>) : ("")}
                                </UniversalLink>
                              </li>
                            );
                          })}
                        </ul>
                      </Accordion.Body>
                    )}
                  </Accordion.Item>
                );
              })}
              <div
                className={`${serviceBarStyles.accordionFullLink} ${serviceBarStyles.accordionButton}`}
              >
                <UniversalLink
                  to={"/chi-siamo"}
                  onClick={() => setActiveKey(null)}
                  className={classNames({
                    [serviceBarStyles.isActive2]: false,
                  })}
                >
                  <MenuConditional
                    label={"Chi Siamo"}
                  />
                </UniversalLink>
              </div>
              <div className={serviceBarStyles.wrapperTestoSottoVoceDiMenu}>
                <Text
                  content={menuMobile?.testoSottoVoceDiMenu}
                  className={serviceBarStyles.testoSottoVoceDiMenu}
                />
              </div>
            </Accordion>
          </div>
        </motion.section>
      </AnimatePresence>
    </>
  );
};

export default ServiceBar;
